

// // import { FileText, Shield, X } from 'lucide-react';
// // import { useState } from 'react';
// // import { useVerifyKycDocument } from 'features/seller/hooks/useVerifyKycDocument';
// // import { formatDateTime } from 'utils/dateFormatter';
// // import { getStatusColor } from '../utils';

// // const VERIFY_DELAY_MS = 5000;

// // const KycTab = ({ seller, sellerId }) => {
// //   const [viewedDocuments, setViewedDocuments] = useState({});
// //   const [verifiableDocuments, setVerifiableDocuments] = useState({});
// //   const [rejectModalOpen, setRejectModalOpen] = useState(false);
// //   const [selectedDocForReject, setSelectedDocForReject] = useState(null);
// //   const [rejectionReason, setRejectionReason] = useState('');
// //   const [documentViewModalOpen, setDocumentViewModalOpen] = useState(false);
// // const [selectedDocumentUrl, setSelectedDocumentUrl] = useState([]);
// //   const { mutate: verifyDocument, isPending: isVerifyingDoc } = useVerifyKycDocument();

// //   // const handleViewDocument = (docId, documentUrl) => {
// //   //   setSelectedDocumentUrl(documentUrl);
// //   //   setDocumentViewModalOpen(true);

// //   //   if (!viewedDocuments[docId]) {
// //   //     setViewedDocuments((prev) => ({ ...prev, [docId]: Date.now() }));

// //   //     setTimeout(() => {
// //   //       setVerifiableDocuments((prev) => ({ ...prev, [docId]: true }));
// //   //     }, VERIFY_DELAY_MS);
// //   //   }
// //   // };

// // const handleViewDocument = (docId, documentUrl) => {
// //   const normalizedUrls = (
// //     Array.isArray(documentUrl)
// //       ? documentUrl
// //       : documentUrl
// //       ? [documentUrl]
// //       : []
// //   ).filter(
// //     (url) =>
// //       typeof url === 'string' &&
// //       url.trim() !== '' &&
// //       url !== 'null' &&
// //       url !== 'undefined'
// //   );

// //   setSelectedDocumentUrl(normalizedUrls);
// //   setDocumentViewModalOpen(true);

// //   if (!viewedDocuments[docId]) {
// //     setViewedDocuments((prev) => ({
// //       ...prev,
// //       [docId]: Date.now(),
// //     }));

// //     setTimeout(() => {
// //       setVerifiableDocuments((prev) => ({
// //         ...prev,
// //         [docId]: true,
// //       }));
// //     }, VERIFY_DELAY_MS);
// //   }
// // };

// //   const canVerifyDocument = (docId) => {
// //     return verifiableDocuments[docId] === true;
// //   };

// //   const handleApproveDocument = (docId) => {
// //     if (canVerifyDocument(docId)) {
// //       verifyDocument({
// //         sellerId,
// //         documentId: docId,
// //         verificationStatus: 'verified',
// //       });
// //     }
// //   };

// //   const handleOpenRejectModal = (doc) => {
// //     setSelectedDocForReject(doc);
// //     setRejectionReason('');
// //     setRejectModalOpen(true);
// //   };

// //   const handleRejectDocument = () => {
// //     if (selectedDocForReject && rejectionReason.trim()) {
// //       verifyDocument(
// //         {
// //           sellerId,
// //           documentId: selectedDocForReject._id,
// //           verificationStatus: 'rejected',
// //           rejectionReason: rejectionReason.trim(),
// //         },
// //         {
// //           onSuccess: () => {
// //             setRejectModalOpen(false);
// //             setSelectedDocForReject(null);
// //             setRejectionReason('');
// //           },
// //         }
// //       );
// //     }
// //   };

// //   return (
// //     <>
// //       {/* KYC Status */}
// //       <div className='bg-card border border-border rounded-lg p-6'>
// //         <h2 className='text-lg font-semibold mb-4 flex items-center'>
// //           <Shield className='mr-2' size={20} />
// //           KYC Status
// //         </h2>
// //         <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
// //           <div>
// //             <label className='text-xs text-muted-foreground'>Status</label>
// //             <p className='text-sm font-medium mt-1 capitalize'>{seller?.kyc?.status?.replace('_', ' ')}</p>
// //           </div>
// //           <div>
// //             <label className='text-xs text-muted-foreground'>Submitted At</label>
// //             <p className='text-sm font-medium mt-1'>
// //               {seller?.kyc?.submittedAt ? formatDateTime(seller.kyc.submittedAt) : 'N/A'}
// //             </p>
// //           </div>
// //           <div>
// //             <label className='text-xs text-muted-foreground'>Approved At</label>
// //             <p className='text-sm font-medium mt-1'>
// //               {seller?.kyc?.approvedAt ? formatDateTime(seller.kyc.approvedAt) : 'N/A'}
// //             </p>
// //           </div>
// //           {/* <div>
// //             <label className='text-xs text-muted-foreground'>Expiry Date</label>
// //             <p className='text-sm font-medium mt-1'>
// //               {seller?.kyc?.expiryDate ? formatDateTime(seller.kyc.expiryDate) : 'N/A'}
// //             </p>
// //           </div> */}
// //         </div>
// //       </div>

// //       {/* KYC Documents */}
// //       <div className='bg-card border border-border rounded-lg p-6'>
// //         <h2 className='text-lg font-semibold mb-2 flex items-center'>
// //           <FileText className='mr-2' size={20} />
// //           KYC Documents
// //         </h2>
// //         {seller?.kyc?.documents?.some(
// //           (doc) => doc.verificationStatus !== 'verified' && doc.verificationStatus !== 'rejected'
// //         ) && (
// //           <p className='text-xs text-muted-foreground mb-4'>
// //             To approve or reject a document, click "View" to review it first. The buttons will be enabled after 5
// //             seconds.
// //           </p>
// //         )}
// //         <div className='space-y-4'>
// //           {seller?.kyc?.documents?.length > 0 ? (
// //             seller.kyc.documents.map((doc) => (
// //               <div key={doc._id} className='border border-border rounded-lg p-4 hover:bg-accent/50 transition-colors'>
// //                 <div className='flex items-start justify-between'>
// //                   <div className='flex-1'>
// //                     <div className='flex items-center gap-2'>
// //                       <h3 className='font-medium text-sm capitalize'>{doc.type?.replace('_', ' ')}</h3>
// //                       <span
// //                         className={`px-2 py-1 text-xs font-medium rounded-full capitalize ${getStatusColor(
// //                           doc.verificationStatus
// //                         )}`}
// //                       >
// //                         {doc.verificationStatus}
// //                       </span>
// //                     </div>
// //                     <p className='text-xs text-muted-foreground mt-1'>Uploaded: {formatDateTime(doc.uploadedAt)}</p>
// //                     {doc.verifiedAt && (
// //                       <p className='text-xs text-muted-foreground'>Verified: {formatDateTime(doc.verifiedAt)}</p>
// //                     )}
// //                     {doc.rejectionReason && (
// //                       <p className='text-xs text-red-600 mt-1'>Reason: {doc.rejectionReason}</p>
// //                     )}
// //                   </div>
// //                   <div className='flex gap-2'>
// //                     <button
// //                       onClick={() => handleViewDocument(doc._id, doc.documentUrl)}
// //                       className='px-3 py-1 text-xs bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
// //                     >
// //                       {viewedDocuments[doc._id] ? 'View Again' : 'View'}
// //                     </button>
// //                     {doc.verificationStatus !== 'verified' && doc.verificationStatus !== 'rejected' && (
// //                       <>
// //                         <button
// //                           onClick={() => handleApproveDocument(doc._id)}
// //                           disabled={!canVerifyDocument(doc._id) || isVerifyingDoc}
// //                           className={`px-3 py-1 text-xs rounded-md transition-colors ${
// //                             canVerifyDocument(doc._id)
// //                               ? 'bg-green-600 text-white hover:bg-green-700 cursor-pointer'
// //                               : 'bg-muted text-muted-foreground cursor-not-allowed opacity-50'
// //                           }`}
// //                         >
// //                           {isVerifyingDoc
// //                             ? 'Processing...'
// //                             : !viewedDocuments[doc._id]
// //                             ? 'View first'
// //                             : !verifiableDocuments[doc._id]
// //                             ? 'Wait...'
// //                             : 'Approve'}
// //                         </button>
// //                         <button
// //                           onClick={() => handleOpenRejectModal(doc)}
// //                           disabled={!canVerifyDocument(doc._id) || isVerifyingDoc}
// //                           className={`px-3 py-1 text-xs rounded-md transition-colors ${
// //                             canVerifyDocument(doc._id)
// //                               ? 'bg-red-600 text-white hover:bg-red-700 cursor-pointer'
// //                               : 'bg-muted text-muted-foreground cursor-not-allowed opacity-50'
// //                           }`}
// //                         >
// //                           {isVerifyingDoc
// //                             ? 'Processing...'
// //                             : !viewedDocuments[doc._id]
// //                             ? 'View first'
// //                             : !verifiableDocuments[doc._id]
// //                             ? 'Wait...'
// //                             : 'Reject'}
// //                         </button>
// //                       </>
// //                     )}
// //                   </div>
// //                 </div>
// //               </div>
// //             ))
// //           ) : (
// //             <p className='text-sm text-muted-foreground'>No documents uploaded</p>
// //           )}
// //         </div>
// //       </div>

// //       {/* Background Check */}
// //       {/* <div className='bg-card border border-border rounded-lg p-6'>
// //         <h2 className='text-lg font-semibold mb-4 flex items-center'>
// //           <Shield className='mr-2' size={20} />
// //           Background Check
// //         </h2>
// //         <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
// //           <div>
// //             <label className='text-xs text-muted-foreground'>Status</label>
// //             <p className='text-sm font-medium mt-1 capitalize'>
// //               {seller?.kyc?.backgroundCheck?.status?.replace('_', ' ') || 'Pending'}
// //             </p>
// //           </div>
// //           <div>
// //             <label className='text-xs text-muted-foreground'>Checked At</label>
// //             <p className='text-sm font-medium mt-1'>
// //               {seller?.kyc?.backgroundCheck?.checkedAt
// //                 ? formatDateTime(seller.kyc.backgroundCheck.checkedAt)
// //                 : 'N/A'}
// //             </p>
// //           </div>
// //           {seller?.kyc?.backgroundCheck?.reportUrl && (
// //             <div className='md:col-span-2'>
// //               <a
// //                 href={seller.kyc.backgroundCheck.reportUrl}
// //                 target='_blank'
// //                 rel='noopener noreferrer'
// //                 className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors inline-block'
// //               >
// //                 View Report
// //               </a>
// //             </div>
// //           )}
// //         </div>
// //       </div> */}

// //       {/* KYC Logs */}
// //       {seller?.kyc?.logs?.length > 0 && (
// //         <div className='bg-card border border-border rounded-lg p-6'>
// //           <h2 className='text-lg font-semibold mb-4'>KYC Activity Logs</h2>
// //           <div className='space-y-3'>
// //             {seller.kyc.logs.map((log) => (
// //               <div key={log._id} className='border-l-2 border-primary pl-4'>
// //                 <p className='text-sm font-medium capitalize'>{log.status?.replace('_', ' ')}</p>
// //                 <p className='text-xs text-muted-foreground'>{formatDateTime(log.changedAt)}</p>
// //                 {log.note && <p className='text-xs mt-1'>{log.note}</p>}
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       )}

// //     {/* Document View Modal */}
// // {documentViewModalOpen && (
// //   <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4'>
// //     <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-5xl max-h-[90vh] flex flex-col'>
// //       <div className='flex items-center justify-between p-4 border-b border-border'>
// //         <h3 className='text-lg font-semibold text-foreground'>
// //           View Document
// //         </h3>

// //         <button
// //           onClick={() => {
// //             setDocumentViewModalOpen(false);
// //             setSelectedDocumentUrl([]);
// //           }}
// //           className='text-muted-foreground hover:text-foreground transition-colors'
// //         >
// //           <X size={20} />
// //         </button>
// //       </div>

// //       <div className='flex flex-col' style={{ height: '75vh' }}>
// //         <div className='flex-1 overflow-hidden p-6 bg-muted/30'>
// //           {(() => {
// //             const validDocuments = (selectedDocumentUrl || []).filter(
// //               (url) =>
// //                 typeof url === 'string' &&
// //                 url.trim() !== '' &&
// //                 url !== 'null' &&
// //                 url !== 'undefined'
// //             );

// //             if (validDocuments.length === 0) {
// //               return (
// //                 <div className='flex items-center justify-center h-full'>
// //                   <p className='text-red-600 font-bold'>
// //                     Failed to load Document
// //                   </p>
// //                 </div>
// //               );
// //             }

// //             return (
// //               <div
// //                 className='grid h-full gap-4'
// //                 style={{
// //                   gridTemplateColumns: `repeat(${validDocuments.length}, minmax(0, 1fr))`,
// //                 }}
// //               >
// //                 {validDocuments.map((url, index) => {
// //                   const cleanUrl = url.split('?')[0];

// //                   const isImage =
// //                     /\.(jpg|jpeg|png|gif|webp)$/i.test(cleanUrl);

// //                   const isPdf =
// //                     /\.pdf$/i.test(cleanUrl);

// //                   return (
// //                     <div
// //                       key={index}
// //                       className='relative w-full h-full overflow-hidden rounded border border-border bg-background flex items-center justify-center'
// //                     >
// //                       {isImage ? (
// //                         <img
// //                           src={url}
// //                           alt={`Document ${index + 1}`}
// //                           className='w-full h-full object-contain'
// //                         />
// //                       ) : isPdf ? (
// //                         <iframe
// //                           src={`${url}#zoom=50`}
// //                           title={`Document ${index + 1}`}
// //                           className='w-full h-full bg-white'
// //                         />
// //                       ) : (
// //                         <div className='flex flex-col items-center gap-2'>
// //                           <p className='text-sm text-muted-foreground'>
// //                             Preview not available
// //                           </p>

// //                           <a
// //                             href={url}
// //                             target='_blank'
// //                             rel='noopener noreferrer'
// //                             className='text-primary underline'
// //                           >
// //                             Open Document
// //                           </a>
// //                         </div>
// //                       )}
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             );
// //           })()}
// //         </div>
// //       </div>

// //       <div className='flex justify-end gap-3 p-4 border-t border-border'>
// //         <button
// //           onClick={() => {
// //             setDocumentViewModalOpen(false);
// //             setSelectedDocumentUrl([]);
// //           }}
// //           className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
// //         >
// //           Close
// //         </button>
// //       </div>
// //     </div>
// //   </div>
// // )}

// //       {/* Reject Document Modal */}
// //       {rejectModalOpen && (
// //         <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
// //           <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-md mx-4'>
// //             <div className='flex items-center justify-between p-6 border-b border-border'>
// //               <h3 className='text-lg font-semibold text-foreground'>Reject Document</h3>
// //               <button
// //                 onClick={() => {
// //                   setRejectModalOpen(false);
// //                   setSelectedDocForReject(null);
// //                   setRejectionReason('');
// //                 }}
// //                 className='text-muted-foreground hover:text-foreground transition-colors'
// //                 disabled={isVerifyingDoc}
// //               >
// //                 <X size={20} />
// //               </button>
// //             </div>

// //             <div className='p-6 space-y-4'>
// //               <div>
// //                 <label htmlFor='rejectionReason' className='block text-sm font-medium text-foreground mb-2'>
// //                   Rejection Reason (Required)
// //                 </label>
// //                 <textarea
// //                   id='rejectionReason'
// //                   value={rejectionReason}
// //                   onChange={(e) => setRejectionReason(e.target.value)}
// //                   rows={3}
// //                   className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-primary'
// //                   placeholder='Enter reason for rejection...'
// //                   required
// //                 />
// //               </div>

// //               <div className='flex justify-end gap-3 pt-4'>
// //                 <button
// //                   type='button'
// //                   onClick={() => {
// //                     setRejectModalOpen(false);
// //                     setSelectedDocForReject(null);
// //                     setRejectionReason('');
// //                   }}
// //                   className='px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-accent transition-colors'
// //                   disabled={isVerifyingDoc}
// //                 >
// //                   Cancel
// //                 </button>
// //                 <button
// //                   onClick={handleRejectDocument}
// //                   disabled={isVerifyingDoc || !rejectionReason.trim()}
// //                   className='px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
// //                 >
// //                   {isVerifyingDoc ? 'Rejecting...' : 'Reject Document'}
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </>
// //   );
// // };

// // export default KycTab;
// import { FileText, Plus, Pencil, Shield, X } from 'lucide-react';
// import { useState } from 'react';
// import { useVerifyKycDocument } from 'features/seller/hooks/useVerifyKycDocument';
// import { useUpsertKycDocument } from 'features/seller/hooks/useUpsertKycDocument';
// import { formatDateTime } from 'utils/dateFormatter';
// import { getStatusColor } from '../utils';
// import KycDocumentModal from 'features/seller/components/KycDocumentModal';

// const VERIFY_DELAY_MS = 5000;

// const KycTab = ({ seller, sellerId }) => {
//   const [viewedDocuments, setViewedDocuments] = useState({});
//   const [verifiableDocuments, setVerifiableDocuments] = useState({});
//   const [rejectModalOpen, setRejectModalOpen] = useState(false);
//   const [selectedDocForReject, setSelectedDocForReject] = useState(null);
//   const [rejectionReason, setRejectionReason] = useState('');
//   const [documentViewModalOpen, setDocumentViewModalOpen] = useState(false);
//   const [selectedDocumentUrl, setSelectedDocumentUrl] = useState([]);

//   // KYC add/edit modal state
//   const [kycModalOpen, setKycModalOpen] = useState(false);
//   const [editingDoc, setEditingDoc] = useState(null); // null = add mode

//   const { mutate: verifyDocument, isPending: isVerifyingDoc } = useVerifyKycDocument();
//   const { mutate: upsertKycDocument, isPending: isUpserting } = useUpsertKycDocument(sellerId);

//   const handleViewDocument = (docId, documentUrl) => {
//     const normalizedUrls = (
//       Array.isArray(documentUrl) ? documentUrl : documentUrl ? [documentUrl] : []
//     ).filter(
//       (url) =>
//         typeof url === 'string' &&
//         url.trim() !== '' &&
//         url !== 'null' &&
//         url !== 'undefined'
//     );

//     setSelectedDocumentUrl(normalizedUrls);
//     setDocumentViewModalOpen(true);

//     if (!viewedDocuments[docId]) {
//       setViewedDocuments((prev) => ({ ...prev, [docId]: Date.now() }));
//       setTimeout(() => {
//         setVerifiableDocuments((prev) => ({ ...prev, [docId]: true }));
//       }, VERIFY_DELAY_MS);
//     }
//   };

//   const canVerifyDocument = (docId) => verifiableDocuments[docId] === true;

//   const handleApproveDocument = (docId) => {
//     if (canVerifyDocument(docId)) {
//       verifyDocument({ sellerId, documentId: docId, verificationStatus: 'verified' });
//     }
//   };

//   const handleOpenRejectModal = (doc) => {
//     setSelectedDocForReject(doc);
//     setRejectionReason('');
//     setRejectModalOpen(true);
//   };

//   const handleRejectDocument = () => {
//     if (selectedDocForReject && rejectionReason.trim()) {
//       verifyDocument(
//         {
//           sellerId,
//           documentId: selectedDocForReject._id,
//           verificationStatus: 'rejected',
//           rejectionReason: rejectionReason.trim(),
//         },
//         {
//           onSuccess: () => {
//             setRejectModalOpen(false);
//             setSelectedDocForReject(null);
//             setRejectionReason('');
//           },
//         }
//       );
//     }
//   };

//   const handleOpenAddModal = () => {
//     setEditingDoc(null);
//     setKycModalOpen(true);
//   };

//   const handleOpenEditModal = (doc) => {
//     setEditingDoc(doc);
//     setKycModalOpen(true);
//   };

//   const handleKycModalSubmit = (payload) => {
//     upsertKycDocument(
//       { documentId: editingDoc?._id ?? null, payload },
//       {
//         onSuccess: () => {
//           setKycModalOpen(false);
//           setEditingDoc(null);
//         },
//       }
//     );
//   };

//   return (
//     <>
//       {/* KYC Status */}
//       <div className='bg-card border border-border rounded-lg p-6'>
//         <h2 className='text-lg font-semibold mb-4 flex items-center'>
//           <Shield className='mr-2' size={20} />
//           KYC Status
//         </h2>
//         <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
//           <div>
//             <label className='text-xs text-muted-foreground'>Status</label>
//             <p className='text-sm font-medium mt-1 capitalize'>
//               {seller?.kyc?.status?.replace('_', ' ')}
//             </p>
//           </div>
//           <div>
//             <label className='text-xs text-muted-foreground'>Submitted At</label>
//             <p className='text-sm font-medium mt-1'>
//               {seller?.kyc?.submittedAt ? formatDateTime(seller.kyc.submittedAt) : 'N/A'}
//             </p>
//           </div>
//           <div>
//             <label className='text-xs text-muted-foreground'>Approved At</label>
//             <p className='text-sm font-medium mt-1'>
//               {seller?.kyc?.approvedAt ? formatDateTime(seller.kyc.approvedAt) : 'N/A'}
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* KYC Documents */}
//       <div className='bg-card border border-border rounded-lg p-6'>
//         <div className='flex items-center justify-between mb-2'>
//           <h2 className='text-lg font-semibold flex items-center'>
//             <FileText className='mr-2' size={20} />
//             KYC Documents
//           </h2>
//           <button
//             onClick={handleOpenAddModal}
//             className='flex items-center gap-1.5 px-3 py-1.5 text-xs bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
//           >
//             <Plus size={13} />
//             Add Document
//           </button>
//         </div>

//         {seller?.kyc?.documents?.some(
//           (doc) =>
//             doc.verificationStatus !== 'verified' && doc.verificationStatus !== 'rejected'
//         ) && (
//           <p className='text-xs text-muted-foreground mb-4'>
//             To approve or reject a document, click "View" to review it first. The buttons will
//             be enabled after 5 seconds.
//           </p>
//         )}

//         <div className='space-y-4'>
//           {seller?.kyc?.documents?.length > 0 ? (
//             seller.kyc.documents.map((doc) => (
//               <div
//                 key={doc._id}
//                 className='border border-border rounded-lg p-4 hover:bg-accent/50 transition-colors'
//               >
//                 <div className='flex items-start justify-between'>
//                   <div className='flex-1'>
//                     <div className='flex items-center gap-2'>
//                       <h3 className='font-medium text-sm capitalize'>
//                         {doc.type?.replace('_', ' ')}
//                       </h3>
//                       <span
//                         className={`px-2 py-1 text-xs font-medium rounded-full capitalize ${getStatusColor(
//                           doc.verificationStatus
//                         )}`}
//                       >
//                         {doc.verificationStatus}
//                       </span>
//                     </div>
//                     <p className='text-xs text-muted-foreground mt-1'>
//                       Uploaded: {formatDateTime(doc.uploadedAt)}
//                     </p>
//                     {doc.verifiedAt && (
//                       <p className='text-xs text-muted-foreground'>
//                         Verified: {formatDateTime(doc.verifiedAt)}
//                       </p>
//                     )}
//                     {doc.rejectionReason && (
//                       <p className='text-xs text-red-600 mt-1'>Reason: {doc.rejectionReason}</p>
//                     )}
//                   </div>

//                   <div className='flex gap-2 flex-wrap justify-end'>
//                     <button
//                       onClick={() => handleViewDocument(doc._id, doc.documentUrl)}
//                       className='px-3 py-1 text-xs bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
//                     >
//                       {viewedDocuments[doc._id] ? 'View Again' : 'View'}
//                     </button>

//                     {/* Edit button — always available */}
//                     <button
//                       onClick={() => handleOpenEditModal(doc)}
//                       className='px-3 py-1 text-xs border border-border rounded-md bg-card hover:bg-accent transition-colors flex items-center gap-1'
//                     >
//                       <Pencil size={11} />
//                       Edit
//                     </button>

//                     {doc.verificationStatus !== 'verified' &&
//                       doc.verificationStatus !== 'rejected' && (
//                         <>
//                           <button
//                             onClick={() => handleApproveDocument(doc._id)}
//                             disabled={!canVerifyDocument(doc._id) || isVerifyingDoc}
//                             className={`px-3 py-1 text-xs rounded-md transition-colors ${
//                               canVerifyDocument(doc._id)
//                                 ? 'bg-green-600 text-white hover:bg-green-700 cursor-pointer'
//                                 : 'bg-muted text-muted-foreground cursor-not-allowed opacity-50'
//                             }`}
//                           >
//                             {isVerifyingDoc
//                               ? 'Processing...'
//                               : !viewedDocuments[doc._id]
//                               ? 'View first'
//                               : !verifiableDocuments[doc._id]
//                               ? 'Wait...'
//                               : 'Approve'}
//                           </button>
//                           <button
//                             onClick={() => handleOpenRejectModal(doc)}
//                             disabled={!canVerifyDocument(doc._id) || isVerifyingDoc}
//                             className={`px-3 py-1 text-xs rounded-md transition-colors ${
//                               canVerifyDocument(doc._id)
//                                 ? 'bg-red-600 text-white hover:bg-red-700 cursor-pointer'
//                                 : 'bg-muted text-muted-foreground cursor-not-allowed opacity-50'
//                             }`}
//                           >
//                             {isVerifyingDoc
//                               ? 'Processing...'
//                               : !viewedDocuments[doc._id]
//                               ? 'View first'
//                               : !verifiableDocuments[doc._id]
//                               ? 'Wait...'
//                               : 'Reject'}
//                           </button>
//                         </>
//                       )}
//                   </div>
//                 </div>
//               </div>
//             ))
//           ) : (
//             <p className='text-sm text-muted-foreground'>No documents uploaded</p>
//           )}
//         </div>
//       </div>

//       {/* KYC Logs */}
//       {seller?.kyc?.logs?.length > 0 && (
//         <div className='bg-card border border-border rounded-lg p-6'>
//           <h2 className='text-lg font-semibold mb-4'>KYC Activity Logs</h2>
//           <div className='space-y-3'>
//             {seller.kyc.logs.map((log) => (
//               <div key={log._id} className='border-l-2 border-primary pl-4'>
//                 <p className='text-sm font-medium capitalize'>
//                   {log.status?.replace('_', ' ')}
//                 </p>
//                 <p className='text-xs text-muted-foreground'>{formatDateTime(log.changedAt)}</p>
//                 {log.note && <p className='text-xs mt-1'>{log.note}</p>}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Document View Modal */}
//       {documentViewModalOpen && (
//         <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4'>
//           <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-5xl max-h-[90vh] flex flex-col'>
//             {/* Header */}
//             <div className='flex items-center justify-between p-4 border-b border-border'>
//               <h3 className='text-lg font-semibold text-foreground'>View Document</h3>
//               <button
//                 onClick={() => {
//                   setDocumentViewModalOpen(false);
//                   setSelectedDocumentUrl([]);
//                 }}
//                 className='text-muted-foreground hover:text-foreground transition-colors'
//               >
//                 <X size={20} />
//               </button>
//             </div>

//             {/* Body */}
//             <div className='flex-1 overflow-hidden p-6 bg-muted/30'>
//               {(() => {
//                 const validDocuments = (selectedDocumentUrl || []).filter(
//                   (url) =>
//                     typeof url === 'string' &&
//                     url.trim() !== '' &&
//                     url !== 'null' &&
//                     url !== 'undefined'
//                 );

//                 if (validDocuments.length === 0) {
//                   return (
//                     <div className='flex items-center justify-center h-full'>
//                       <p className='text-red-600 font-bold'>Failed to load Document</p>
//                     </div>
//                   );
//                 }

//                 return (
//                   <div
//                     className='grid h-full gap-4'
//                     style={{
//                       gridTemplateColumns: `repeat(${validDocuments.length}, minmax(0, 1fr))`,
//                     }}
//                   >
//                     {validDocuments.map((url, index) => {
//                       const cleanUrl = url.split('?')[0];
//                       const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(cleanUrl);
//                       const isPdf = /\.pdf$/i.test(cleanUrl);

//                       return (
//                         <div
//                           key={index}
//                           className='relative w-full h-full overflow-hidden rounded border border-border bg-background flex items-center justify-center'
//                         >
//                           {isImage ? (
//                             <img
//                               src={url}
//                               alt={`Document ${index + 1}`}
//                               className='w-full h-full object-contain'
//                             />
//                           ) : isPdf ? (
//                             <iframe
//                               src={`${url}#zoom=50`}
//                               title={`Document ${index + 1}`}
//                               className='w-full h-full bg-white'
//                             />
//                           ) : (
//                             <div className='flex flex-col items-center gap-2'>
//                               <p className='text-sm text-muted-foreground'>
//                                 Preview not available
//                               </p>
//                               <a
//                                 href={url}
//                                 target='_blank'
//                                 rel='noopener noreferrer'
//                                 className='text-primary underline'
//                               >
//                                 Open Document
//                               </a>
//                             </div>
//                           )}
//                         </div>
//                       );
//                     })}
//                   </div>
//                 );
//               })()}
//             </div>

//             {/* Footer */}
//             <div className='flex justify-end gap-3 p-4 border-t border-border'>
//               <button
//                 onClick={() => {
//                   setDocumentViewModalOpen(false);
//                   setSelectedDocumentUrl([]);
//                 }}
//                 className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Reject Document Modal */}
//       {rejectModalOpen && (
//         <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
//           <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-md mx-4'>
//             <div className='flex items-center justify-between p-6 border-b border-border'>
//               <h3 className='text-lg font-semibold text-foreground'>Reject Document</h3>
//               <button
//                 onClick={() => {
//                   setRejectModalOpen(false);
//                   setSelectedDocForReject(null);
//                   setRejectionReason('');
//                 }}
//                 className='text-muted-foreground hover:text-foreground transition-colors'
//                 disabled={isVerifyingDoc}
//               >
//                 <X size={18} />
//               </button>
//             </div>
//             <div className='p-6 space-y-4'>
//               <div>
//                 <label className='block text-sm font-medium text-foreground mb-2'>
//                   Rejection Reason (Required)
//                 </label>
//                 <textarea
//                   value={rejectionReason}
//                   onChange={(e) => setRejectionReason(e.target.value)}
//                   rows={3}
//                   className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-primary'
//                   placeholder='Enter reason for rejection...'
//                 />
//               </div>
//               <div className='flex justify-end gap-3 pt-4'>
//                 <button
//                   type='button'
//                   onClick={() => {
//                     setRejectModalOpen(false);
//                     setSelectedDocForReject(null);
//                     setRejectionReason('');
//                   }}
//                   className='px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-accent transition-colors'
//                   disabled={isVerifyingDoc}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={handleRejectDocument}
//                   disabled={isVerifyingDoc || !rejectionReason.trim()}
//                   className='px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
//                 >
//                   {isVerifyingDoc ? 'Rejecting...' : 'Reject Document'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add / Edit KYC Document Modal */}
//       <KycDocumentModal
//         isOpen={kycModalOpen}
//         onClose={() => {
//           setKycModalOpen(false);
//           setEditingDoc(null);
//         }}
//         onSubmit={handleKycModalSubmit}
//         existingDoc={editingDoc}
//         isSubmitting={isUpserting}
//       />
//     </>
//   );
// };

// export default KycTab;



import { FileText, Plus, Pencil, Shield, X } from 'lucide-react';
import { useState } from 'react';
import { useVerifyKycDocument } from 'features/seller/hooks/useVerifyKycDocument';
import { useUpsertKycDocument } from 'features/seller/hooks/useUpsertKycDocument';
import { formatDateTime } from 'utils/dateFormatter';
import { getStatusColor } from '../utils';
import KycDocumentModal from 'features/seller/components/KycDocumentModal';

const VERIFY_DELAY_MS = 5000;

const KycTab = ({ seller, sellerId }) => {
  const [viewedDocuments, setViewedDocuments] = useState({});
  const [verifiableDocuments, setVerifiableDocuments] = useState({});
  const [rejectModalOpen, setRejectModalOpen] = useState(false);
  const [selectedDocForReject, setSelectedDocForReject] = useState(null);
  const [rejectionReason, setRejectionReason] = useState('');
  const [documentViewModalOpen, setDocumentViewModalOpen] = useState(false);
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState([]);
  const [selectedDocumentInfo, setSelectedDocumentInfo] = useState(null); // { type, documentNumber }

  // Tracks which specific document AND which action (approve/reject) is
  // currently in flight, so the "Processing..." state only applies to the
  // exact button clicked instead of every button sharing the single
  // mutation's isPending flag.
  const [processing, setProcessing] = useState(null); // { docId, action } | null

  // KYC add/edit modal state
  const [kycModalOpen, setKycModalOpen] = useState(false);
  const [editingDoc, setEditingDoc] = useState(null); // null = add mode

  const { mutate: verifyDocument, isPending: isVerifyingDoc } = useVerifyKycDocument();
  const { mutate: upsertKycDocument, isPending: isUpserting } = useUpsertKycDocument(sellerId);

  const handleViewDocument = (docId, documentUrl, type, documentNumber) => {
    const normalizedUrls = (
      Array.isArray(documentUrl) ? documentUrl : documentUrl ? [documentUrl] : []
    ).filter(
      (url) =>
        typeof url === 'string' &&
        url.trim() !== '' &&
        url !== 'null' &&
        url !== 'undefined'
    );

    setSelectedDocumentUrl(normalizedUrls);
    setSelectedDocumentInfo({ type, documentNumber });
    setDocumentViewModalOpen(true);

    if (!viewedDocuments[docId]) {
      setViewedDocuments((prev) => ({ ...prev, [docId]: Date.now() }));
      setTimeout(() => {
        setVerifiableDocuments((prev) => ({ ...prev, [docId]: true }));
      }, VERIFY_DELAY_MS);
    }
  };

  const canVerifyDocument = (docId) => verifiableDocuments[docId] === true;

  const handleApproveDocument = (docId) => {
    if (canVerifyDocument(docId)) {
      setProcessing({ docId, action: 'approve' });
      verifyDocument(
        { sellerId, documentId: docId, verificationStatus: 'verified' },
        {
          onSettled: () => setProcessing(null),
        }
      );
    }
  };

  const handleOpenRejectModal = (doc) => {
    setSelectedDocForReject(doc);
    setRejectionReason('');
    setRejectModalOpen(true);
  };

  const handleRejectDocument = () => {
    if (selectedDocForReject && rejectionReason.trim()) {
      setProcessing({ docId: selectedDocForReject._id, action: 'reject' });
      verifyDocument(
        {
          sellerId,
          documentId: selectedDocForReject._id,
          verificationStatus: 'rejected',
          rejectionReason: rejectionReason.trim(),
        },
        {
          onSuccess: () => {
            setRejectModalOpen(false);
            setSelectedDocForReject(null);
            setRejectionReason('');
          },
          onSettled: () => setProcessing(null),
        }
      );
    }
  };

  const handleOpenAddModal = () => {
    setEditingDoc(null);
    setKycModalOpen(true);
  };

  const handleOpenEditModal = (doc) => {
    setEditingDoc(doc);
    setKycModalOpen(true);
  };

  const handleKycModalSubmit = (payload) => {
    upsertKycDocument(
      { documentId: editingDoc?._id ?? null, payload },
      {
        onSuccess: () => {
          setKycModalOpen(false);
          setEditingDoc(null);
        },
      }
    );
  };

  return (
    <>
      {/* KYC Status */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <h2 className='text-lg font-semibold mb-4 flex items-center'>
          <Shield className='mr-2' size={20} />
          KYC Status
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
          <div>
            <label className='text-xs text-muted-foreground'>Status</label>
            <p className='text-sm font-medium mt-1 capitalize'>
              {seller?.kyc?.status?.replace('_', ' ')}
            </p>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Submitted At</label>
            <p className='text-sm font-medium mt-1'>
              {seller?.kyc?.submittedAt ? formatDateTime(seller.kyc.submittedAt) : 'N/A'}
            </p>
          </div>
          <div>
            <label className='text-xs text-muted-foreground'>Approved At</label>
            <p className='text-sm font-medium mt-1'>
              {seller?.kyc?.approvedAt ? formatDateTime(seller.kyc.approvedAt) : 'N/A'}
            </p>
          </div>
        </div>
      </div>

      {/* KYC Documents */}
      <div className='bg-card border border-border rounded-lg p-6'>
        <div className='flex items-center justify-between mb-2'>
          <h2 className='text-lg font-semibold flex items-center'>
            <FileText className='mr-2' size={20} />
            KYC Documents
          </h2>
          <button
            onClick={handleOpenAddModal}
            className='flex items-center gap-1.5 px-3 py-1.5 text-xs bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
          >
            <Plus size={13} />
            Add Document
          </button>
        </div>

        {seller?.kyc?.documents?.some(
          (doc) =>
            doc.verificationStatus !== 'verified' && doc.verificationStatus !== 'rejected'
        ) && (
          <p className='text-xs text-muted-foreground mb-4'>
            To approve or reject a document, click "View" to review it first. The buttons will
            be enabled after 5 seconds.
          </p>
        )}

        <div className='space-y-4'>
          {seller?.kyc?.documents?.length > 0 ? (
            seller.kyc.documents.map((doc) => {
              // Only true for the exact button (doc + action) actually
              // submitted right now — approving doesn't affect reject's
              // state and vice versa.
              const isApproveProcessing =
                isVerifyingDoc &&
                processing?.docId === doc._id &&
                processing?.action === 'approve';

              const isRejectProcessing =
                isVerifyingDoc &&
                processing?.docId === doc._id &&
                processing?.action === 'reject';

              const isThisDocProcessing = isApproveProcessing || isRejectProcessing;

              return (
                <div
                  key={doc._id}
                  className='border border-border rounded-lg p-4 hover:bg-accent/50 transition-colors'
                >
                  <div className='flex items-start justify-between'>
                    <div className='flex-1'>
                      <div className='flex items-center gap-2'>
                        <h3 className='font-medium text-sm capitalize'>
                          {doc.type?.replace('_', ' ')}
                        </h3>
                        <span
                          className={`px-2 py-1 text-xs font-medium rounded-full capitalize ${getStatusColor(
                            doc.verificationStatus
                          )}`}
                        >
                          {doc.verificationStatus}
                        </span>
                      </div>
                      <p className='text-sm mt-1'>
                        <span className='text-muted-foreground'>Document Number: </span>
                        <span className='font-medium text-foreground'>
                          {doc.documentNumber || 'Not provided'}
                        </span>
                      </p>
                      <p className='text-xs text-muted-foreground mt-1'>
                        Uploaded: {formatDateTime(doc.uploadedAt)}
                      </p>
                      {doc.verifiedAt && (
                        <p className='text-xs text-muted-foreground'>
                          Verified: {formatDateTime(doc.verifiedAt)}
                        </p>
                      )}
                      {doc.rejectionReason && (
                        <p className='text-xs text-red-600 mt-1'>Reason: {doc.rejectionReason}</p>
                      )}
                    </div>

                    <div className='flex gap-2 flex-wrap justify-end'>
                      <button
                        onClick={() =>
                          handleViewDocument(doc._id, doc.documentUrl, doc.type, doc.documentNumber)
                        }
                        className='px-3 py-1 text-xs bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
                      >
                        {viewedDocuments[doc._id] ? 'View Again' : 'View'}
                      </button>

                      {/* Edit button — always available */}
                      <button
                        onClick={() => handleOpenEditModal(doc)}
                        className='px-3 py-1 text-xs border border-border rounded-md bg-card hover:bg-accent transition-colors flex items-center gap-1'
                      >
                        <Pencil size={11} />
                        Edit
                      </button>

                      {doc.verificationStatus !== 'verified' &&
                        doc.verificationStatus !== 'rejected' && (
                          <>
                            <button
                              onClick={() => handleApproveDocument(doc._id)}
                              disabled={
                                !canVerifyDocument(doc._id) || isThisDocProcessing
                              }
                              className={`px-3 py-1 text-xs rounded-md transition-colors ${
                                canVerifyDocument(doc._id)
                                  ? 'bg-green-600 text-white hover:bg-green-700 cursor-pointer'
                                  : 'bg-muted text-muted-foreground cursor-not-allowed opacity-50'
                              }`}
                            >
                              {isApproveProcessing
                                ? 'Processing...'
                                : !viewedDocuments[doc._id]
                                ? 'View first'
                                : !verifiableDocuments[doc._id]
                                ? 'Wait...'
                                : 'Approve'}
                            </button>
                            <button
                              onClick={() => handleOpenRejectModal(doc)}
                              disabled={
                                !canVerifyDocument(doc._id) || isThisDocProcessing
                              }
                              className={`px-3 py-1 text-xs rounded-md transition-colors ${
                                canVerifyDocument(doc._id)
                                  ? 'bg-red-600 text-white hover:bg-red-700 cursor-pointer'
                                  : 'bg-muted text-muted-foreground cursor-not-allowed opacity-50'
                              }`}
                            >
                              {isRejectProcessing
                                ? 'Processing...'
                                : !viewedDocuments[doc._id]
                                ? 'View first'
                                : !verifiableDocuments[doc._id]
                                ? 'Wait...'
                                : 'Reject'}
                            </button>
                          </>
                        )}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <p className='text-sm text-muted-foreground'>No documents uploaded</p>
          )}
        </div>
      </div>

      {/* KYC Logs */}
      {seller?.kyc?.logs?.length > 0 && (
        <div className='bg-card border border-border rounded-lg p-6'>
          <h2 className='text-lg font-semibold mb-4'>KYC Activity Logs</h2>
          <div className='space-y-3'>
            {seller.kyc.logs.map((log) => (
              <div key={log._id} className='border-l-2 border-primary pl-4'>
                <p className='text-sm font-medium capitalize'>
                  {log.status?.replace('_', ' ')}
                </p>
                <p className='text-xs text-muted-foreground'>{formatDateTime(log.changedAt)}</p>
                {log.note && <p className='text-xs mt-1'>{log.note}</p>}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Document View Modal */}
      {documentViewModalOpen && (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4'>
          <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-5xl max-h-[90vh] flex flex-col'>
            {/* Header */}
            <div className='flex items-center justify-between p-4 border-b border-border'>
              <div>
                <h3 className='text-lg font-semibold text-foreground capitalize'>
                  View {selectedDocumentInfo?.type?.replace('_', ' ') || 'Document'}
                </h3>
                <p className='text-sm text-muted-foreground mt-0.5'>
                  Document Number:{' '}
                  <span className='font-medium text-foreground'>
                    {selectedDocumentInfo?.documentNumber || 'Not provided'}
                  </span>
                </p>
              </div>
              <button
                onClick={() => {
                  setDocumentViewModalOpen(false);
                  setSelectedDocumentUrl([]);
                  setSelectedDocumentInfo(null);
                }}
                className='text-muted-foreground hover:text-foreground transition-colors'
              >
                <X size={20} />
              </button>
            </div>

            {/* Body */}
            <div className='flex-1 overflow-hidden p-6 bg-muted/30'>
              {(() => {
                const validDocuments = (selectedDocumentUrl || []).filter(
                  (url) =>
                    typeof url === 'string' &&
                    url.trim() !== '' &&
                    url !== 'null' &&
                    url !== 'undefined'
                );

                if (validDocuments.length === 0) {
                  return (
                    <div className='flex items-center justify-center h-full'>
                      <p className='text-red-600 font-bold'>Failed to load Document</p>
                    </div>
                  );
                }

                return (
                  <div
                    className='grid h-full gap-4'
                    style={{
                      gridTemplateColumns: `repeat(${validDocuments.length}, minmax(0, 1fr))`,
                    }}
                  >
                    {validDocuments.map((url, index) => {
                      const cleanUrl = url.split('?')[0];
                      const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(cleanUrl);
                      const isPdf = /\.pdf$/i.test(cleanUrl);

                      return (
                        <div
                          key={index}
                          className='relative w-full h-full overflow-hidden rounded border border-border bg-background flex items-center justify-center'
                        >
                          {isImage ? (
                            <img
                              src={url}
                              alt={`Document ${index + 1}`}
                              className='w-full h-full object-contain'
                            />
                          ) : isPdf ? (
                            <iframe
                              src={`${url}#zoom=50`}
                              title={`Document ${index + 1}`}
                              className='w-full h-full bg-white'
                            />
                          ) : (
                            <div className='flex flex-col items-center gap-2'>
                              <p className='text-sm text-muted-foreground'>
                                Preview not available
                              </p>
                              <a
                                href={url}
                                target='_blank'
                                rel='noopener noreferrer'
                                className='text-primary underline'
                              >
                                Open Document
                              </a>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
            </div>

            {/* Footer */}
            <div className='flex justify-end gap-3 p-4 border-t border-border'>
              <button
                onClick={() => {
                  setDocumentViewModalOpen(false);
                  setSelectedDocumentUrl([]);
                  setSelectedDocumentInfo(null);
                }}
                className='px-4 py-2 text-sm bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors'
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Reject Document Modal */}
      {rejectModalOpen && (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm'>
          <div className='bg-card border border-border rounded-lg shadow-lg w-full max-w-md mx-4'>
            <div className='flex items-center justify-between p-6 border-b border-border'>
              <h3 className='text-lg font-semibold text-foreground'>Reject Document</h3>
              <button
                onClick={() => {
                  setRejectModalOpen(false);
                  setSelectedDocForReject(null);
                  setRejectionReason('');
                }}
                className='text-muted-foreground hover:text-foreground transition-colors'
                disabled={isVerifyingDoc}
              >
                <X size={18} />
              </button>
            </div>
            <div className='p-6 space-y-4'>
              <div>
                <label className='block text-sm font-medium text-foreground mb-2'>
                  Rejection Reason (Required)
                </label>
                <textarea
                  value={rejectionReason}
                  onChange={(e) => setRejectionReason(e.target.value)}
                  rows={3}
                  className='w-full px-3 py-2 text-sm border border-border rounded-md bg-background focus:outline-none focus:ring-2 focus:ring-primary'
                  placeholder='Enter reason for rejection...'
                />
              </div>
              <div className='flex justify-end gap-3 pt-4'>
                <button
                  type='button'
                  onClick={() => {
                    setRejectModalOpen(false);
                    setSelectedDocForReject(null);
                    setRejectionReason('');
                  }}
                  className='px-4 py-2 text-sm border border-border rounded-md bg-card hover:bg-accent transition-colors'
                  disabled={isVerifyingDoc}
                >
                  Cancel
                </button>
                <button
                  onClick={handleRejectDocument}
                  disabled={isVerifyingDoc || !rejectionReason.trim()}
                  className='px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed'
                >
                  {isVerifyingDoc ? 'Rejecting...' : 'Reject Document'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add / Edit KYC Document Modal */}
      <KycDocumentModal
        isOpen={kycModalOpen}
        onClose={() => {
          setKycModalOpen(false);
          setEditingDoc(null);
        }}
        onSubmit={handleKycModalSubmit}
        existingDoc={editingDoc}
        isSubmitting={isUpserting}
      />
    </>
  );
};

export default KycTab;